module.exports = __webpack_public_path__ + "img/chevron-down.78a65aa9.svg";